import SignMessageScreen from './SignMessageScreen'

export default SignMessageScreen
